import { User } from './types'

export const isSubscriber = (user?: User): boolean => !!(user && user.subscription)
